// extracted by mini-css-extract-plugin
export default {"card":"Face3_card__6CnLM"};